export default {
  title: '_17度'
}



// WEBPACK FOOTER //
// ./src/config/title.js